<template>
    <div class="expertCard" @click="navTo">
        <img :src="cardData.Head">
        <div id="mes">
            <p id="name">{{cardData.Name}}</p>
            <p>
                <span class="head">现任职务：</span>
                <span class="text">{{cardData.Profession}}</span>
            </p>
            <p>
                <span class="head">从事方向（研究方向)：</span>
                <span class="text">{{cardData.ResearchDirection}}</span>
            </p>
            <p>
                <span class="head">联系方式：</span>
                <span class="text">{{cardData.Phone}}</span>
            </p>
            <p>
                <span class="head">邮箱：</span>
                <span class="text">{{cardData.Email}}</span>
            </p>
        </div>
    </div>
</template>
<script>
export default {
  name: "expertCard",
  props: {
    cardData: Object
  },
  methods: {
    navTo() {
      this.$router.push(`/experts/detail?id=${this.cardData.ExpertId}`)
    }
  }
};
</script>
<style lang="scss" scoped>
.expertCard {
  display: flex;
  color: #333333;
  transition: .2s;
  cursor: pointer;
  &:hover {
    #name {
      text-decoration: underline;
    }
    background: #f8f8f8;
  }
  img {
    width: 150Px;
    height: 200Px;
  }
  #mes {
    margin-left: 32px;
    display: flex;
    flex:1;
    flex-direction: column;
    justify-content: space-around;
  }
}
#name {
  font-size: 20px;
}
.head {
  font-size: 16px;
}
.text {
  font-size: 16px;
  color: #909399;
}
</style>

